class GPProIframeResize extends EventTarget {
    constructor(id, element, allowedOrigins = [ '*' ]) {
        super()
        this.id = id
        this.element = element
        this.allowedOrigins = allowedOrigins
        this.onReadyCallback = () => { }
    }

    start(onReady = () => { }) {
        this.onReadyCallback = onReady
        this._handshakeHandler()
        window.addEventListener('message', e => {
            if (!(this.allowedOrigins.includes(e.origin))) return
            try {
                const message = JSON.parse(e.data ?? { })
                const { event = null, data = null } = message
                if (event) {
                    this.dispatchEvent(new CustomEvent(event, {
                        detail: { data, origin: e.origin }
                    }))
                } else {
                    console.warn('Message format not valid')
                }
            } catch (e) {
                console.warn('Cannot parse message', e)
            }
        }, false)
    }

    _handshakeHandler() {
        const event = this.id + '_handshake'
        this.addEventListener(event, ({ detail: { data, origin } }) => {
            const { handshakeId = null } = data
            this.element.contentWindow.postMessage(handshakeId, origin)
            this.onReadyCallback?.()
        })
    }

    sendMessage(event, data) {
        this.element.contentWindow.postMessage(JSON.stringify({ event, data }), document.location.origin)
    }
}

(() => {
    const iframes = Array.from(document.querySelectorAll('iframe.js-autoresize'))
    for (const iframe of iframes) {
        const iframeOrigin = (new URL(iframe.getAttribute('src'))).origin
        const messageHandler = new GPProIframeResize('NAOLIB', iframe, [ iframeOrigin ])
        messageHandler.start(() => {
            messageHandler.addEventListener('ask-resize', ({ detail: { data } }) => {
                const { height = null } = data
                if (Number.isFinite(height)) {
                    iframe.style.height = height + 'px'
                }
            })
        })
    }
})()